import { RequestEvent } from 'state-data';

export class EmailChangeRequestSentEvent extends RequestEvent {}
